import { render, staticRenderFns } from "./DsnPagination.vue?vue&type=template&id=46c1b3fe&scoped=true&"
import script from "./DsnPagination.vue?vue&type=script&lang=js&"
export * from "./DsnPagination.vue?vue&type=script&lang=js&"
import style0 from "./DsnPagination.vue?vue&type=style&index=0&id=46c1b3fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c1b3fe",
  null
  
)

export default component.exports